import React from "react";

const ChevronRight = ({ display = "block" }) => (
  <svg
    className={`fill-current ${display}`}
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M12.1464466,5.14644661 L12.8535534,5.85355339 C13.0488155,6.04881554 13.0488155,6.36539803 12.8535534,6.56066017 L7.85355339,11.5606602 C7.65829124,11.7559223 7.34170876,11.7559223 7.14644661,11.5606602 L2.14644661,6.56066017 C1.95118446,6.36539803 1.95118446,6.04881554 2.14644661,5.85355339 L2.85355339,5.14644661 C3.04881554,4.95118446 3.36539803,4.95118446 3.56066017,5.14644661 L7.14644661,8.73223305 C7.34170876,8.92749519 7.65829124,8.92749519 7.85355339,8.73223305 L11.4393398,5.14644661 C11.634602,4.95118446 11.9511845,4.95118446 12.1464466,5.14644661 Z"
        fill="currentColor"
        fillRule="nonzero"
        transform="translate(7.500000, 8.353553) rotate(-90.000000) translate(-7.500000, -8.353553) "
      />
    </g>
  </svg>
);

export default ChevronRight;
